import * as classNames from 'classnames';
import * as React from 'react';

import * as styles from './Section.css';

export interface ISectionProps {
  id?: string;
  title?: string;
  marginTop?: number;
}

const SectionComponent: React.FC<ISectionProps> = ({ id, title, children, marginTop }) => {
  return (
    <section
      className={classNames(styles['container'], !marginTop && styles['margin'])}
      style={{ marginTop: marginTop ? `${marginTop}px` : '' }}
      id={id}
    >
      {title && <h2 className={styles['title']}>{title}</h2>}
      {children}
    </section>
  );
};

export const Section = React.memo<React.PropsWithChildren<ISectionProps>>(SectionComponent);
